import {memo} from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEqual';
import {calculateEventHeight, calculateEventLeft, calculateEventTop, getReviewData} from '../../../../../utils/edReviewUtils';
import DailyCalendarTile from './dailyCalendarTile/dailyCalendarTile';
import {COLUMN_GAP, DEFAULT_LEFT, OFFSET, SLOT_HEIGHT} from '../edReviewCalendarDaily';
import {useDispatch} from 'react-redux';
import {getEdReviewSessionDetails} from '../../../../../../../../../store/reducers/reviews';

const EdReviewTiles = ({ reviews, colWidth, findEventIndex, leftOffset, onSelectPatient }) => {
  const dispatch = useDispatch();

  return (
    !isEmpty(reviews) ? reviews?.map((patient) => {
      const reviewData = getReviewData(patient);
      const parentSession = dispatch(getEdReviewSessionDetails({ sessionId: reviewData?.assignedSession }));

      return (
        !!reviewData?.assignedSession && (
          <DailyCalendarTile
            event={patient}
            id={patient?.__id}
            onSelectTime={(ev) => onSelectPatient(ev, patient)}
            key={`${reviewData?.assignedSession}_${reviewData?.date}`}
            options={{
              top: calculateEventTop({
                event: patient,
                slotHeight: SLOT_HEIGHT,
                offset: OFFSET,
                isReview: true,
              }),
              left: calculateEventLeft({
                event: patient,
                columnIndex: 0,
                // columnIndex: findEventIndex(getReviewData(patient)?.assignedSession),
                leftOffset: DEFAULT_LEFT + leftOffset,
                columnGap: COLUMN_GAP,
                eventSlotWidth: colWidth,
                offset: OFFSET,
                isReview: true,
              }),
              height: calculateEventHeight({
                event: patient,
                eventSlotHeight: SLOT_HEIGHT,
                offset: OFFSET,
                isReview: true,
                parentSession,
              }),
              width: colWidth,
            }}
          />
        ));
    }) : null
  );
}

EdReviewTiles.propTypes = {
  reviews: PropTypes.array,
  colWidth: PropTypes.string,
  findEventIndex: PropTypes.func,
  onSelectPatient: PropTypes.func,
  leftOffset: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default memo(EdReviewTiles, _isEqual);